var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 61,
    viewBox: "0 0 204 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6s0d43xzwa",
    d: "M0 0h204v61H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "t1v0tsfrob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6s0d43xzwa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.441 61.092H7.468c-4.157 0-7.559-3.437-7.559-7.637V7.636C-.09 3.436 3.311 0 7.47 0H196.44C200.598 0 204 3.436 204 7.636v45.82c0 4.2-3.402 7.636-7.559 7.636",
    fill: "#0A0B09",
    mask: "url(#t1v0tsfrob)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.441 0H7.468C3.311 0-.09 3.436-.09 7.636v45.82c0 4.2 3.402 7.636 7.56 7.636H196.44c4.157 0 7.559-3.437 7.559-7.637V7.636c0-4.2-3.402-7.636-7.559-7.636zm0 1.222c3.501 0 6.35 2.877 6.35 6.414v45.82c0 3.536-2.849 6.414-6.35 6.414H7.468c-3.501 0-6.35-2.878-6.35-6.415V7.636c0-3.537 2.849-6.414 6.35-6.414h188.973z",
    fill: "#9D9E9A",
    mask: "url(#t1v0tsfrob)"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "LucidaGrande, Lucida Grande",
    fontSize: 11.427,
    letterSpacing: 0.027,
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 65.052,
    y: 16.564
  }, "GET IT"), /*#__PURE__*/React.createElement("tspan", {
    x: 101.026,
    y: 16.564,
    letterSpacing: -0.201
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 104.44,
    y: 16.564
  }, "ON")), /*#__PURE__*/React.createElement("g", {
    fontFamily: "LucidaGrande, Lucida Grande",
    fontSize: 11.427,
    fill: "#000",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(61.954 4.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.489,
    y: 11.709
  }, "G")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(61.954 4.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.781,
    y: 11.718
  }, "E")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(61.954 4.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.954,
    y: 11.718
  }, "T")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(61.954 4.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 27.873,
    y: 11.718
  }, "I")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(61.954 4.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31.334,
    y: 11.718
  }, "T")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(61.954 4.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41.27,
    y: 11.718
  }, "O")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(61.954 4.855)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 51.786,
    y: 11.718
  }, "N"))), /*#__PURE__*/React.createElement("path", {
    d: "M161.573 45.819h2.821V26.725h-2.82v19.094zm25.409-12.216-3.234 8.278h-.097l-3.356-8.278h-3.038l5.034 11.57-2.871 6.436h2.942l7.757-18.006h-3.137zm-16 10.047c-.922 0-2.211-.467-2.211-1.62 0-1.474 1.605-2.04 2.99-2.04 1.24 0 1.825.27 2.578.639-.22 1.769-1.727 3.021-3.356 3.021zm.342-10.463c-2.042 0-4.157.908-5.032 2.923l2.503 1.055c.535-1.055 1.532-1.4 2.578-1.4 1.459 0 2.942.884 2.966 2.457v.195c-.511-.294-1.606-.736-2.942-.736-2.7 0-5.447 1.499-5.447 4.298 0 2.555 2.213 4.202 4.693 4.202 1.895 0 2.943-.86 3.598-1.868h.098v1.475h2.724v-7.32c0-3.39-2.506-5.281-5.739-5.281zm-17.434 2.741h-4.012v-6.544h4.012c2.11 0 3.307 1.764 3.307 3.271 0 1.48-1.198 3.273-3.307 3.273zm-.072-9.202h-6.76V45.82h2.82v-7.234h3.94c3.126 0 6.2-2.286 6.2-5.93 0-3.643-3.074-5.929-6.2-5.929zm-36.859 16.929c-1.949 0-3.58-1.65-3.58-3.913 0-2.29 1.631-3.962 3.58-3.962 1.923 0 3.433 1.672 3.433 3.962 0 2.263-1.51 3.913-3.433 3.913zm3.238-8.982h-.096c-.634-.763-1.852-1.453-3.385-1.453-3.216 0-6.164 2.856-6.164 6.522 0 3.64 2.948 6.47 6.164 6.47 1.533 0 2.751-.688 3.385-1.475h.096v.934c0 2.486-1.315 3.813-3.433 3.813-1.73 0-2.801-1.254-3.24-2.312l-2.46 1.034c.707 1.721 2.581 3.838 5.7 3.838 3.312 0 6.114-1.969 6.114-6.766V33.614h-2.68v1.059zm4.63 11.146h2.823V26.725h-2.824v19.094zm6.988-6.299c-.072-2.51 1.925-3.789 3.361-3.789 1.122 0 2.071.567 2.389 1.378l-5.75 2.411zm8.769-2.166c-.537-1.45-2.168-4.134-5.505-4.134-3.312 0-6.065 2.635-6.065 6.497 0 3.641 2.729 6.496 6.381 6.496 2.947 0 4.652-1.82 5.36-2.88l-2.193-1.476c-.731 1.083-1.729 1.798-3.167 1.798-1.436 0-2.46-.666-3.115-1.97l8.595-3.593-.291-.738zm-68.496-2.14v2.756h6.528c-.197 1.55-.708 2.682-1.488 3.468-.95.961-2.435 2.02-5.04 2.02-4.02 0-7.161-3.273-7.161-7.333 0-4.06 3.141-7.333 7.16-7.333 2.169 0 3.75.862 4.92 1.97l1.925-1.945c-1.633-1.575-3.8-2.781-6.844-2.781-5.506 0-10.134 4.528-10.134 10.089 0 5.56 4.628 10.088 10.134 10.088 2.97 0 5.211-.985 6.965-2.83 1.802-1.82 2.363-4.379 2.363-6.447 0-.638-.049-1.23-.147-1.721h-9.181zm16.749 8.44c-1.949 0-3.63-1.624-3.63-3.937 0-2.338 1.681-3.937 3.63-3.937 1.947 0 3.628 1.599 3.628 3.937 0 2.313-1.68 3.938-3.628 3.938zm0-10.434c-3.557 0-6.455 2.732-6.455 6.497 0 3.74 2.898 6.496 6.455 6.496 3.556 0 6.454-2.755 6.454-6.496 0-3.765-2.898-6.497-6.454-6.497zm14.08 10.435c-1.95 0-3.63-1.625-3.63-3.938 0-2.338 1.68-3.937 3.63-3.937 1.948 0 3.627 1.599 3.627 3.937 0 2.313-1.68 3.938-3.628 3.938zm0-10.435c-3.557 0-6.455 2.732-6.455 6.497 0 3.74 2.898 6.496 6.454 6.496 3.556 0 6.454-2.755 6.454-6.496 0-3.765-2.898-6.497-6.454-6.497z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.229 29.666 15.134 46.924l.002.011c.494 1.874 2.188 3.253 4.198 3.253.804 0 1.559-.218 2.206-.604l.053-.031L39.71 38.992l-8.481-9.326",
    fill: "#D84037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.512 26.728-.015-.011-7.822-4.58-8.812 7.922 8.844 8.931 7.78-4.534a4.402 4.402 0 0 0 2.29-3.874 4.393 4.393 0 0 0-2.265-3.854",
    fill: "#F1B628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.133 14.169c-.097.36-.147.739-.147 1.13v30.497c0 .39.05.77.148 1.128l16.648-16.817-16.65-15.938",
    fill: "#5373AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.348 30.547 8.33-8.413-18.096-10.6a4.32 4.32 0 0 0-2.248-.628c-2.01 0-3.707 1.383-4.2 3.258l-.001.005 16.215 16.378",
    fill: "#319F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.8c21e6d65b856dd0b68374a2f7cd9466.svg";
export { ForwardRef as ReactComponent };